import { provideChameleonDesignSystem } from '@getgo/chameleon-toolkit';
import { chameleonDataTable } from './DataTable.definition';
import { chameleonDataTableBody } from './DataTableBody/DataTableBody.definition';
import { chameleonDataTableCell } from './DataTableCell/DataTableCell.definition';
import { chameleonDataTableHeader } from './DataTableHeader/DataTableHeader.definition';
import { chameleonDataTableRow } from './DataTableRow/DataTableRow.definition';
provideChameleonDesignSystem().register(chameleonDataTable(), chameleonDataTableBody(), chameleonDataTableCell(), chameleonDataTableHeader(), chameleonDataTableRow());
